import React, { useState } from 'react';
import { Icon } from '@perch-labs/shrike';
import { copyFor } from 'config';
import {
  ButtonContainer,
  ExpandButton,
  Gradient,
  Wrapper,
} from './accordion-fade.style';

const getCopy = copyFor('modules.sources');

interface Props {
  children: React.ReactNode;
  className?: string;
  previewGradientPercent?: string;
  previewHeight?: string;
}

export const AccordionFade = ({
  children,
  className = '',
  previewGradientPercent = '30%',
  previewHeight = '190px',
}: Props) => {
  const [expanded, setExpanded] = useState(false);
  return (
    <Wrapper
      className={className}
      expanded={expanded}
      previewHeight={previewHeight}
    >
      {children}
      {!expanded && <Gradient percent={previewGradientPercent} />}
      {!expanded && (
        <ButtonContainer>
          <ExpandButton aria-hidden={true} onClick={() => setExpanded(true)}>
            {`${getCopy('expandButtonText')} `}
            <Icon
              color="secondary"
              icon="ChevronDown"
              margin={{ left: '8px' }}
            />
          </ExpandButton>
        </ButtonContainer>
      )}
    </Wrapper>
  );
};
